import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import * as React from 'react'
import {Headlines, InnerContainer, Option, PrimaryText, Select} from '../../../../shared/components/Elements'
import { Headline, SubHeadline } from '../../../../shared/components/Headlines'
import {
  Content,
  ContentContainerBody,
  ContentRow,
  FlexItem,
  SplitContentContainer
} from '../../../../shared/components/Content'
import { SideInformation } from '../../../../shared/components/SideInformation'
import { Button, ButtonBar, NextButton } from '../../../../shared/components/Button'
import { SegmentedProgressBar } from '../result/SegmentedProgressBar'
import { autobind } from 'core-decorators'
import {Jaw, JawTranslation} from '../../../../shared/Constants'
import { CalculatorStoreInstance } from '../../../../stores/CalculatorStore'
import { History } from 'history'
import {Routes} from "../../../Routes";
import {breakpoint, styled} from "../../../../shared/styled-components";
import {Utils} from "../../../../shared/Utils";
import { InfoTooltip } from '../../../../shared/InfoTooltip'

interface IProps {
  jaw: Jaw
  store?: CalculatorStoreInstance
  history?: History
}

@(withRouter as any)
@inject('store')
@observer
export class NonRemovableReplacementView extends React.Component<IProps> {
  // -------------------------------------------------------------------------- LIFECYCLE

  componentDidMount () {
    const { store, jaw } = this.props
    const requirement = store!.offer.getJawRequirement(jaw)
    const jawRoute = Routes.getJawRoute(jaw)
    const validReplacementTypes = ['non_removable', 'all_on_4', 'all_on_6']
    // if (validReplacementTypes.indexOf(requirement?.fullReplacementType) === -1) {
    //   return store!.redirectToRoute(jawRoute)
    // }
  }

  // -------------------------------------------------------------------------- EVENTS

  @autobind
  private _onStandardNextClick (e) {
    e.preventDefault()

    const { store, jaw } = this.props
    const requirement = store!.offer.getJawRequirement(jaw)
    requirement.setFullReplacementType('non_removable')
    const route = Routes.getJawRoute(jaw)
    return store!.redirectToRoute(route.subRoutes.recommendations)
  }

  @autobind
  private _onAllOn4NextClick (e) {
    e.preventDefault()

    const { store, jaw } = this.props
    const requirement = store!.offer.getJawRequirement(jaw)
    requirement.setFullReplacementType('all_on_4')

    const route = Routes.getJawRoute(jaw)
    return store!.redirectToRoute(route.subRoutes.allOn4)
  }

  // -------------------------------------------------------------------------- RENDERING
  render () {
    const { store, jaw } = this.props

    return (<InnerContainer padded>
      <Headlines>
        <Headline centered>Unsere Empfehlung - {JawTranslation[jaw]}</Headline>
        <SubHeadline centered>Durch Ihre Auswahl empfehlen wir Ihnen folgenden Zahnersatz:</SubHeadline>
      </Headlines>

      <Content>
        <Headline>Zahnersatz festsitzend</Headline>
        <ContentContainer>
          <ContentContainerBody>
            <Column padded vertical>
              <div>
                <SectionHeadline as="h3">Konventioneller Zahnersatz <PrimaryText>auf 6 Implantaten</PrimaryText></SectionHeadline>

                <OptionContainer>
                  <OptionImage src={Utils.getAssetPath('/assets/calculator/' + jaw + '_jaw_non_removable.png')} />
                  <OptionText>Bei einem festsitzenden Zahnersatz für einen zahnlosen Kiefer entscheidet der Behandler, ob die prothetische Versorgung verschraubt oder zementiert wird.</OptionText>
                </OptionContainer>
              </div>

              <Buttons>
                <NextButton primary onClick={this._onStandardNextClick}>Auswählen & Weiter</NextButton>
              </Buttons>
            </Column>
            <Column padded vertical>
              <div>
                <SectionHeadline as="h3">All-on-4® <PrimaryText>Feste Zähne an einem Tag <InlineTooltip small>Diese Art der Versorgung kann nicht immer und nur bei ausreichendem Restknochenangebot durchgeführt werden. Hier ist zur endgültigen Entscheidung über die Durchführbarkeit in der Regel eine 3-D Röntgendiagnostik in der Praxis notwendig.</InlineTooltip></PrimaryText></SectionHeadline>

                <OptionContainer>
                  <OptionImage src={Utils.getAssetPath('/assets/calculator/' + jaw + '_jaw_all_on_4.png')} />
                  <OptionText>
                    Das Nobel Biocare All-on-4® Behandlungskonzept ist eine bewährte Zahnimplantatlösung speziell für Patienten mit zahnlosem Kiefer oder nicht erhaltungswürdiger Bezahnung.
                  </OptionText>
                </OptionContainer>
              </div>

              <Buttons>
                <AllOn4Button as="a" small href="https://implacheck.de/all-on-4" target="_blank">Mehr über das All-on-4®-Prinzip</AllOn4Button>
                <NextButton primary onClick={this._onAllOn4NextClick}>Auswählen & Weiter</NextButton>
              </Buttons>
            </Column>
          </ContentContainerBody>
          <SideInformation
              onBackClick={() => store!.goBack()}
              onNextClick={this._onNextClick}
              infoText={jaw === 'upper'
                  ? 'der implacheck®-Implantatkostenrechner Ihnen Ihre individuelle Kalkulation kostenfrei per Mail zur Verfügung stellt?'
                  : 'Sie als Angstpatient die Behandlung auch in Dämmerschlaf oder Vollnarkose durchführen können?'
              }
              longInfoText={jaw === 'upper'
                  ? 'der implacheck®-Implantatkostenrechner Ihnen Ihre individuelle Kalkulation kostenfrei per Mail zur Verfügung stellt? Damit Sie aus unserem Rechner die größtmöglichen Vorteile ziehen erhalten Sie die Kalkulation der Implantatkosten für Ihre Zahnsituation per E-Mail. Sie können sich am Ende des Rechners eintragen und erhalten dadurch zusätzlich Zugriff auf exklusive Tipps rund um das Thema Implantologie und Ihre Zahngesundheit. Sie können den Rechner so nutzen, um den Heil- und Kostenplan Ihres Behandlers mit den Konditionen einer implacheck®-Versorgung zu vergleichen.'
                  : 'Sie als Angstpatient die Behandlung auch in Dämmerschlaf oder Vollnarkose durchführen können? Im Falle einer nachgewiesenen Angststörung werden die Kosten von Ihrer Krankenkasse übernommen. Eine solche können Sie sich bei einem Neurologen oder Psychologen bescheinigen lassen. Viele unserer Behandler bieten Ihnen die Optionen Dämmerschlaf- oder Vollnarkose direkt in ihren Praxen an und beraten Sie im ersten Gespräch gerne individuell.'
              }/>
        </ContentContainer>
      </Content>

      <ButtonBar>
        <Button onClick={() => store!.goBack()}>Zurück</Button>
        <SegmentedProgressBar segmentCount={2} segment={0} />
        <div />
      </ButtonBar>
    </InnerContainer>)
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${breakpoint('tablet')`
    flex-direction: row;
  `}
`

const Left = styled.div`
  flex: 1 1 0;
  ${breakpoint('tablet')`
    margin-right: 50px;
    border-right: 1px solid ${props => props.theme.borderColor};
  `}
`

const Right = styled.div`
  flex: 1 1 0;
  padding-top: 30px;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${props => !props.noMinHeight && 'min-height: 580px;'};
  ${breakpoint('tablet')`
    flex-direction: row;
  `}
`

const SectionHeadline = styled(Headline)`
  font-size: 20px;
  font-weight: normal;
  
  ${breakpoint('tablet')`
    font-size: 20px;
  `}
 
  > span {
    display: block;
  }
`

const Buttons = styled.div`
  margin-top: 10px;
`

const AllOn4Button = styled(Button)`
  margin-bottom: 10px;
  ${breakpoint('tablet')`
    margin-bottom: 10px;
  `};
}
`

const Column = styled(ContentRow)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const OptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`

const OptionImage = styled.img`
  margin-right: 10px;
  width: 40%;
  flex: 0 0 40%;
`

const OptionText = styled.div`
  font-size: 12px;   
`

const InlineTooltip = styled(InfoTooltip)`
  display: inline-block;
`